/*
  Coluna de compra fixa na rolagem (PDP).

  O CSS sozinho ja resolve quando a coluna cabe na tela. Ela tem ~960px de
  altura (preco, numeracao, retirada nas 3 lojas, apoio e WhatsApp) e a janela
  de trabalho aqui tem 779 de altura util: com `top` fixo a coluna grudaria pelo
  topo e o fim dela nunca apareceria.

  Entao o `top` acompanha a DIRECAO da rolagem: descendo, a coluna anda junto
  ate o fim dela encostar no fim da tela e para ali; subindo, volta ate grudar
  pelo topo. Nada some, e o preco e a numeracao continuam na tela o tempo todo.
*/
(function () {
  var MARGEM = 24; // respiro em relacao ao topo e ao fim da tela
  var UMA_COLUNA = 990; // abaixo disso a PDP empilha e nao existe coluna lateral

  var coluna = document.querySelector('[data-brisa-fixa]');
  if (!coluna) return;

  var topo = MARGEM;
  var ultimoY = window.scrollY;
  var agendado = false;

  function aplicar() {
    agendado = false;

    if (window.innerWidth < UMA_COLUNA) {
      coluna.style.top = '';
      return;
    }

    // sobra negativa = a coluna e mais alta que a tela
    var sobra = window.innerHeight - coluna.offsetHeight - MARGEM;
    var y = window.scrollY;

    if (sobra >= 0) {
      topo = MARGEM;
      ultimoY = y;
      coluna.style.top = MARGEM + 'px';
      return;
    }

    var andou = y - ultimoY;
    ultimoY = y;
    topo = Math.min(MARGEM, Math.max(sobra, topo - andou));
    coluna.style.top = Math.round(topo) + 'px';
  }

  function agendar() {
    if (agendado) return;
    agendado = true;
    window.requestAnimationFrame(aplicar);
  }

  window.addEventListener('scroll', agendar, { passive: true });
  window.addEventListener('resize', agendar);

  // a retirada em loja chega depois do carregamento e muda a altura da coluna
  if (window.ResizeObserver) new ResizeObserver(agendar).observe(coluna);

  aplicar();
})();
